














import { Component, Vue, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

import { SiteForDisplay as SiteForDisplayModel } from '../store/models';

import { sitesModuleName } from '../store/index';
import { Actions } from '../store/actions';
import { Getters } from '../store/getters';
import { Busy } from '@/components/Busy';
const sitesModule = namespace(sitesModuleName);

@Component({
  components: {
  },
})
export default class SiteForDisplay extends Vue {

  @Prop() private code!: string;

  private busy: Busy = new Busy();
  private site: SiteForDisplayModel | undefined = {code: '', displayname: '', html: ''};

  @sitesModule.Getter(Getters.SITE_FOR_DISPLAY) private getSiteForDisplay!: (code: string) => SiteForDisplayModel | undefined;
  @sitesModule.Getter(Getters.FETCHED) private isFetched!: boolean;
  @sitesModule.Action(Actions.FETCH_SITES) private fetchSites!: any;

  public async created() {
    await this.ensureSitesAreFetched().then(() => {
      this.site = this.getSiteForDisplay(this.code);
    });
  }

  private async ensureSitesAreFetched() {
    if (!this.isFetched) {
        this.busy.SetBusy();
        await this.fetchSites();
        this.busy.SetFree();
      }
  }

  get siteExists() {
    return this.site !== undefined;
  }

}
